<app-doc-viewer
  title="Time filter"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/time-filter">
    <mat-grid-list cols="2" rowHeight="500px" gutterSize="16px">
      <mat-grid-tile>
        <igo-map-browser [map]="map" [view]="view">
          <div class="map-actions --vertical --bottom --right">
            <igo-zoom-button [map]="map" color="primary" />
          </div>
        </igo-map-browser>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="flex align-start h-100 w-100">
          <igo-panel title="Layers" class="w-100">
            <igo-time-filter-list [layers]="map.layerController.all" />
          </igo-panel>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </app-example-viewer>
</app-doc-viewer>
